const data = {
	"width": 24,
	"height": 24,
	"hidden": true,
	"body": "<path d=\"M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z\" fill=\"currentColor\"/>"
};
export default data;
